import React, { Component } from 'react'
import twitterIcon from '../../images/social-twitter.png';
import linkedinIcon from '../../images/social-linkedin.png';
import instagramIcon from '../../images/social-instagram.png';
import dribbbleIcon from '../../images/social-dribbble.png';
import youtubeIcon from '../../images/social-youtube.png';

class SocialMedia extends Component {
  render() {
    return (
      <ul className='social-media'>
        <li><a href='https://twitter.com/pixelstackcom'><img src={twitterIcon} alt='twitter' /></a></li>
        <li><a href='https://www.linkedin.com/in/jaymiejones/'><img src={linkedinIcon} alt='linkedin' /></a></li>
        <li><a href='https://instagram.com/jaymiejones86'><img src={instagramIcon} alt='instagram' /></a></li>
        <li><a href='https://dribbble.com/jaymiejones86'><img src={dribbbleIcon} alt='dribbble' /></a></li>
        <li><a href='https://youtube.com/codercatchup'><img src={youtubeIcon} alt='youtube' /></a></li>
      </ul>
    );
  }
}

export default SocialMedia



// WEBPACK FOOTER //
// ./src/components/SocialMedia/index.js